/**
 * Backfill wrappers: some functions that uses the `backfill` library that doesn't require them to be inside a class
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get createBackfillCacheConfig () {
        return createBackfillCacheConfig;
    },
    get createBackfillLogger () {
        return createBackfillLogger;
    }
});
const _os = /*#__PURE__*/ _interop_require_wildcard(require("os"));
const _backfillconfig = require("backfill-config");
const _backfilllogger = require("backfill-logger");
const _CredentialCache = require("./CredentialCache.js");
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function createBackfillLogger() {
    const stdout = process.stdout;
    const stderr = process.stderr;
    return (0, _backfilllogger.makeLogger)("error", {
        console: {
            info (...args) {
                stdout.write(args.join(" ") + _os.EOL);
            },
            warn (...args) {
                stderr.write(args.join(" ") + _os.EOL);
            },
            error (...args) {
                stderr.write(args.join(" ") + _os.EOL);
            }
        }
    });
}
function createBackfillCacheConfig(cwd, cacheOptions = {}, backfillLogger) {
    const envConfig = (0, _backfillconfig.getEnvConfig)(backfillLogger);
    const mergedConfig = {
        ...(0, _backfillconfig.createDefaultConfig)(cwd),
        ...cacheOptions,
        ...envConfig
    };
    if (mergedConfig.cacheStorageConfig.provider === "azure-blob") {
        const azureOptions = mergedConfig.cacheStorageConfig.options;
        if ("connectionString" in azureOptions && !isTokenConnectionString(azureOptions.connectionString)) {
            /** Pass through optional credentialName from config to select a specific credential implementation
       * Type assertion: only the connection-string variant is augmented with credentialName in @lage-run/config
       */ const name = azureOptions.credentialName;
            if (name != null) {
                if (!_CredentialCache.CredentialCache.credentialNames.includes(name)) {
                    throw new Error(`Invalid cacheStorageConfig.options.credentialName: "${name}". Allowed values: ${_CredentialCache.CredentialCache.credentialNames.join(", ")}`);
                }
                azureOptions.credential = _CredentialCache.CredentialCache.getInstance(name);
            } else {
                /** No name provided in config: if env var AZURE_IDENTITY_CREDENTIAL_NAME is set, honor it; otherwise default to EnvironmentCredential
         */ const envName = process.env.AZURE_IDENTITY_CREDENTIAL_NAME;
                if (envName != null) {
                    if (!_CredentialCache.CredentialCache.credentialNames.includes(envName)) {
                        throw new Error(`Invalid AZURE_IDENTITY_CREDENTIAL_NAME: "${envName}". Allowed values: ${_CredentialCache.CredentialCache.credentialNames.join(", ")}`);
                    }
                    azureOptions.credential = _CredentialCache.CredentialCache.getInstance(envName);
                } else {
                    // Fall back to EnvironmentCredential
                    azureOptions.credential = _CredentialCache.CredentialCache.getInstance();
                }
            }
        }
    }
    return mergedConfig;
}
function isTokenConnectionString(connectionString) {
    return connectionString.includes("SharedAccessSignature") || connectionString.includes("AccountKey");
}
